<div class="schedule-gantt">
  <div class="schedule-gantt__header">
    <div>
      <h3>{{ 'Schedule Gantt' | translate }}</h3>
      <p>
        {{ 'Cron start times' | translate }}
        <span class="muted">{{ 'Times in time zone' | translate:{ timeZone: timeZone } }}</span>
      </p>
    </div>
    <div class="window-chips">
      @for (chip of windowChips; track chip.id) {
        <button
          type="button"
          class="filter-chip"
          [class.active]="windowHours() === chip.id"
          (click)="selectWindow(chip.id)"
        >
          <span>{{ chip.label | translate }}</span>
        </button>
      }
    </div>
  </div>

  @if (groupChips().length) {
    <div class="group-chips" role="group" [attr.aria-label]="'Schedule Gantt' | translate">
      <button
        type="button"
        class="filter-chip"
        [class.active]="selectedGroup() === 'all'"
        (click)="selectGroup('all')"
      >
        <span>{{ 'All' | translate }}</span>
      </button>
      @for (chip of groupChips(); track chip.id) {
        <button
          type="button"
          class="filter-chip"
          [class.active]="selectedGroup() === chip.id"
          (click)="selectGroup(chip.id)"
        >
          <i [class]="chip.icon" aria-hidden="true"></i>
          <span>{{ chip.labelKey | translate }}</span>
        </button>
      }
    </div>
  }

  @if (overlapCount() > 0) {
    <p class="overlap-banner">
      {{ 'Overlapping starts' | translate:{ count: overlapCount() } }}
    </p>
  }

  @if (noStarts()) {
    <p class="empty muted">{{ 'No scheduled starts in this window' | translate }}</p>
  }

  @if (empty()) {
    <p class="empty muted">{{ 'No process subscriptions found' | translate }}</p>
  } @else {
    <div class="gantt-axis" aria-hidden="true">
      <span class="gantt-axis__label"></span>
      <div class="gantt-axis__track">
        @for (tick of ticks(); track tick.atMs) {
          <span class="gantt-axis__tick" [style.left.%]="tick.leftPercent">{{ tick.label }}</span>
        }
      </div>
    </div>

    <div class="gantt-rows">
      @for (section of groupSections(); track section.id) {
        <section class="gantt-group">
          <header class="gantt-group__title">
            <i [class]="section.icon" aria-hidden="true"></i>
            <h4>{{ section.labelKey | translate }}</h4>
            <app-secondary-button
              [title]="'SUBSCRIPTIONS_DISABLE_MODULE' | translate:{ count: section.activeSubscriptionCount }"
              icon="pause"
              [disable]="disablingModule() !== null || section.activeSubscriptionCount === 0"
              [loading]="disablingModule() === section.id"
              (action)="disableModule.emit(section.id)"
            ></app-secondary-button>
          </header>
          @for (row of section.rows; track row.id) {
            <div class="gantt-row" [class.inactive]="!row.isActive">
              <div class="gantt-row__label">
                @if (row.detailsUrl) {
                  <a [routerLink]="row.detailsUrl">{{ row.name | translate }}</a>
                } @else {
                  <strong>{{ row.name | translate }}</strong>
                }
                <small>{{ row.processLabel | translate }}</small>
                @if (row.usesNextFireOnly) {
                  <small class="muted">{{ 'Next known fire only' | translate }}</small>
                }
              </div>
              <div class="gantt-row__track">
                @for (mark of row.marks; track mark.leftPercent) {
                  <span
                    class="gantt-mark"
                    [class.overlapping]="mark.overlapping"
                    [class.dense]="mark.dense"
                    [style.left.%]="mark.leftPercent"
                    [style.width.%]="mark.widthPercent"
                    [pTooltip]="mark.tooltip"
                    tooltipPosition="top"
                  ></span>
                }
              </div>
            </div>
          }
        </section>
      }
    </div>
  }
</div>
